export const Intersect = 'intersect';
export const Union = 'union';
